import { useEffect } from "react";
import {
  msUntilNextLocalMidnight,
  resetDailyTasksIfNeeded,
} from "../utils/dailyTaskReset";

/**
 * Resets daily habit checkmarks at the start of each local day.
 * Runs on login and again shortly after local midnight if the app stays open.
 */
export function useDailyTaskReset(user) {
  useEffect(() => {
    const userId = user?.uid;
    if (!userId) return;

    let cancelled = false;
    let midnightTimer;

    const runReset = async () => {
      if (cancelled) return;
      try {
        await resetDailyTasksIfNeeded(userId);
      } catch (err) {
        console.warn("Daily task reset skipped:", err?.message || err);
      }
      if (!cancelled) scheduleMidnightReset();
    };

    const scheduleMidnightReset = () => {
      if (cancelled) return;
      midnightTimer = window.setTimeout(runReset, msUntilNextLocalMidnight());
    };

    const onVisibilityChange = () => {
      if (document.visibilityState === "visible") runReset();
    };

    runReset();
    document.addEventListener("visibilitychange", onVisibilityChange);

    return () => {
      cancelled = true;
      if (midnightTimer) window.clearTimeout(midnightTimer);
      document.removeEventListener("visibilitychange", onVisibilityChange);
    };
  }, [user?.uid]);
}
